import {
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  LOCALE_ID,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import {
  BlockForm,
  BlockTypeEnum,
  Field,
  FieldType,
  FormModel,
  FormState,
  FormType,
  ReponseState,
  ResponseStateInstruction
} from '../models';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';

import {ResponseFormModel} from '../models/response-form.model';
import {ResponseForm} from '../models/responsedemat.model';
import {ResponseValueField} from '../models/fielddemat.model';
import {ReponseField} from '../models/responsevaluedemat.model';
import {FormStateChangedModel} from '../form-states/form-state-changed.model';
import {FormulaireService} from '../../../services/formulaire/formulaire.service';
import {SubSink} from '@Common/core/utils/subsink';
import {
  Individu,
  IndividuExterne,
  IndividuFactoryService,
  IndividuService,
  PubSubService,
  TypeIndividu
} from '@Common/core/services';
import {roles} from '../../../enum/roles';
import {Constants} from '../form-builder/common/constants';
import {DatePipe} from '@angular/common';
import {SnackBarToastyService, typeToast} from '@Common/widgets/general/snack-bar';
import {DomSanitizer} from '@angular/platform-browser';
import * as FileSaver from 'file-saver';
import {saveAs} from 'file-saver';
import {ResponsesService} from '../../../services/responses/responses.service';
import * as dateFnsAdaptor from 'date-fns';
import {ListParameters} from '@Services/base/daoService';
import {finalize, map, tap} from 'rxjs/operators';
import {of, Subscription} from 'rxjs';
import {HttpEventType} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {fr} from 'date-fns/locale';
import {ConditionBlockResponseDemat} from "app/demat/common/components/form/models/blockdemat.model";

/**
 * Formulaire de saisie d'une demande
 */
@Component({
  selector: 'app-form-render',
  templateUrl: './form-render.component.html',
  styleUrls: ['./form-render.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FormRenderComponent implements OnInit, OnDestroy, OnChanges {
  @Input() formModel: FormModel;
  @Input() demandeId: number;
  @Input() reference: string;
  @Input() creationAuto: boolean;
  /**
   * par default on affiche les bloc public
   */
  @Input() blockType = BlockTypeEnum.Public;
  /**
   * Activation ou non des boutons
   * true : non actifs
   * false : actifs
   */
  @Input() submitted = false;
  /**
   * Est-ce que les boutons sont visibles
   * cas :
   *  - demandeur : oui
   *  - gestion pour test : non
   */
  @Input() canSave = true;
  @Output() emitResponse: EventEmitter<ResponseFormModel> = new EventEmitter<ResponseFormModel>();
  @Output() emitState: EventEmitter<FormState> = new EventEmitter<FormState>();
  @ViewChildren('fileInput')
  inputFiles: QueryList<any>;

  fieldType = FieldType;
  reponseState = ReponseState;
  lastInstructionState = ResponseStateInstruction;
  filterForm: UntypedFormGroup;
  blocks: BlockForm[];
  formId: number;
  choices: any[] = [];
  subSink = new SubSink();
  connecte: Individu | IndividuExterne;
  blockTypeEnum = BlockTypeEnum;
  nullValues: any = Constants.FieldsNullValues;
  constants: any = Constants;
  fileFieldsKeys: any[] = [];
  filesToUploadObject = {};
  fullFilesToUploadObject: { [fieldKey: string]: File } = {};
  userAlreadyRespondToSurvey: boolean;
  userResponse: ResponseForm;
  lastNonTempState: ReponseState | null = null;
  /** Uploads immédiats en cours, par clé de champ */
  private uploadSubs = new Map<number, Subscription>();
  /** Progression (%) des uploads en cours, par clé de champ */
  private uploadProgress = new Map<number, number>();

  constructor(@Inject(LOCALE_ID) private locale: string,
              private router: Router,
              private pubSubSvc: PubSubService,
              private fb: UntypedFormBuilder,
              private individuService: IndividuFactoryService,
              private snackSvc: SnackBarToastyService,
              private formSvc: FormulaireService,
              private responsesSvc: ResponsesService,
              public sanitizer: DomSanitizer,
              private route: ActivatedRoute) {

  }

  ngOnChanges(changes: SimpleChanges) {
    const sessionId = crypto.randomUUID();
    console.log('Session ID:', sessionId);

    if (changes && this.formModel) {
      this.formId = this.formModel.id;
      this.blocks = this.getFormModelBlocksByType();
      this.filterForm = this.generateFilterForm();
      this.userResponse = this.formModel?.form_responses && this.formModel?.form_responses[0];
    }
  }

  stateResponseChip(response: ResponseForm) {
    return this.responsesSvc.stateDisplay(response?.state);
  }
  stateInstructionChip(response: ResponseForm) {
    return this.responsesSvc.stateInstructionDisplayColor(response);
  }
  getFormModelBlocksByType() {
    return this.formModel.blocks.filter(blk => blk.type === this.blockType);
  }

  checkIfResponseToSondageExist() {
    if (this.isSondage() && this.connecte) {
      const filter = new Map<string, string>();
      filter.set('user_user', this.connecte.user.toString());
      filter.set('form', this.formModel.id.toString());
      const parameters = <ListParameters> {
        extraParams: filter,
        sort: 'order'
      };
      this.pubSubSvc.publish('loading', true);
      return this.responsesSvc.listItems(parameters).pipe(
        map(res => res.list),
        tap(resp => {
          this.userAlreadyRespondToSurvey = !!(resp.length) && (resp[0].state === ReponseState.published);
          this.userResponse = resp[0];
          this.submitted = (this.userAlreadyRespondToSurvey) ? true : this.submitted;
        }),
        finalize(() => this.pubSubSvc.publish('loading', false))
      );
    }
    return of(null);
  }

  visualize(response: ResponseForm) {
    this.router.navigate(['demande/visualiser', response.uuid]);
  }

  checkIfSondageIsOver() {
    if (this.isSondage() && this.formModel.date_fin) {
      // Un sondage n'est plus accessible a partir de dt+1
      const dt = dateFnsAdaptor.addDays(new Date(this.formModel.date_fin), 1);
      return dateFnsAdaptor.isAfter(new Date(), dt);
    }
    return false;
  }

  isSondage() {
    return this.formModel.type === FormType.Sondage;
  }


  checkIfUserCanRespond() {
    if (this.checkIfSondageIsOver()) {
      this.submitted = true;
    } else {
      this.subSink.sink =  this.checkIfResponseToSondageExist().subscribe();
    }

  }
  ngOnInit() {
    this.subSink.sink = this.individuService.individu$.pipe(
      tap(individu => this.connecte = individu)
    ).subscribe();
    if(this.creationAuto){
      this._emitForm(this.reponseState.draft);
    }
    this.checkIfUserCanRespond();
  }

  /**
   * Permet de numéroter les blocks : 01 block1, 02 block2, ..., 12 block12
   * @param {number} indexBlock : indice du block courant
   */
  getBlockPrefixDesign(indexBlock: number) {
    return String(indexBlock + 1).padStart(2, '0');
  }

  sortFields(fields) {
    this.formSvc.fieldsSort(fields);
    return fields;
  }

  isGestionnaire() {
    if (this.connecte) {
      if (this.connecte.type === TypeIndividu.intern) {
        const _indsce = this.individuService.individuService() as IndividuService;
        return _indsce.hasRole(this.connecte as Individu, roles.gestionnaire) ||  _indsce.hasRole(this.connecte as Individu, roles.admin);
      }
    }
    return false;
  }

  generateFilterForm(): UntypedFormGroup {
    const baseForm = this.fb.group({});
    this.formModel.blocks.forEach(block => baseForm.addControl(block.key, this.generateFormGroup(baseForm, block)));
    return baseForm;
  }

  onChangedState(state: FormStateChangedModel) {
    this.formModel.state = state.afterState;
    this.subSink.sink = this.formSvc.patch(this.formModel, 'uuid').subscribe(_ => {
    });
  }

  /**
   * Contrôle de groupe dans lequel il y aura tous les contrôles de champs
   * @param {FormGroup} baseForm
   * @param {BlockForm} block
   */
  generateFormGroup(baseForm: UntypedFormGroup, block: BlockForm): UntypedFormGroup {
    if (block.fields_objs) {
      const formGroup = this.fb.group({});
      block.fields_objs.forEach(field => this._generateFieldControl(field, formGroup));
      const conditionValue = !block?.condition_obj?.is_active; // pas de condition on affiche le block
      const conditionValueResponse = this._getConditionBlockValue(block.id); // valeur d'affichage du block
      baseForm.addControl(this.formCondtionBlockName(block.key), new UntypedFormControl(conditionValue || conditionValueResponse, null));
      return formGroup;
    } else {
      baseForm.addControl(block.key, new UntypedFormControl(''));
    }
    return baseForm;
  }
  private _generateFieldControl(field, formGroup) {
    const field_key = field.key.toString();
    switch (field.options_obj.controlType) {
      case FieldType.TypeCheckbox:
        formGroup.addControl(field_key, this._generateCheckBoxGroup(field));
        break;
      case FieldType.TypeRadio:
        formGroup.addControl(field_key, this._generateRadioField(field));
        break;
      default:
        formGroup.addControl(field_key, this._generateFormField(field));
        break;
    }
  }
  /**
   * Mapping champs formulaire vers ce qu'il y a à envoyer et à enregistrer côté backend
   * - en mode modification de la réponse, les valeurs des champs sont mis à jour
   * la date est reformatée dans les 2 modes : modification et création d'une réponse
   */
  _mapFormToResponsesValuesFields(): ResponseValueField[] {
    const responsesvaluesFields: ResponseValueField[] = [];
    Object.entries(this.filterForm.value).forEach(_value => { // [1] : les fields des blocks - [0] : block id
      Object.entries(_value[1]).forEach(_field => { // [0] : fieldid, [1] : valeur
        let value = _field[1];
        const responseField = this._findResponseFieldById(Number(_field[0]));
        if (responseField) { // mis à jour champs formulaire réponse
          const field_response = responseField.field as Field;
          value = this._transformFieldIfDate(field_response, value);
          responsesvaluesFields.push(<ResponseValueField>{
            id: responseField.id,
            field: Number(_field[0]),
            value: value
          });
        } else { // en création
          const findField = this._findFormFieldById(Number(_field[0]));
          if (findField && findField.options_obj.controlType === FieldType.TypeDate) {
            const control = this.fieldControl(findField.block, findField.id);
            control.patchValue(this._transformFieldIfDate(findField, value));
          }
        }
      });
    });

    // en mode edition on change les keys de l'objet filesToUploadObject
    // on met les ids de la reponseValue au lieu de la key de field
    let remoteJob = {};
    const result = responsesvaluesFields
      .filter(res => this.fileFieldsKeys.includes(res.field))
      .map(value => {
        const obj = {};
        obj[value.id] = this.filesToUploadObject[value.field];
        remoteJob = {...remoteJob, ...obj};
        return obj;
      });
    this.filesToUploadObject = (result.length > 0) ? remoteJob : this.filesToUploadObject;
    return responsesvaluesFields;
  }

  /**
   * Envoi des valeurs
   * @param {ReponseState} reponseStatus
   */
  onSubmit(reponseStatus: ReponseState) {
    this.filesToUploadObject = { ...this.fullFilesToUploadObject };
    this._emitForm(reponseStatus);
    // Reset to initial empty state
    this.fullFilesToUploadObject = {};
  }

  public fieldControl(blockId, fieldId) {
    return this.filterForm.get(`block-${blockId}`).get(`${fieldId}`);
  }

  onKeyDownPhone(blockId, fieldId, event: KeyboardEvent) {
    const keyDown = event.key;
    return !isNaN(+keyDown) || /* seulement un nombre */
      this._checkKeyDown(keyDown, event.ctrlKey); /* autorise d'autres touches touches */
  }

  onPastePhone(blockId, fieldId, event: ClipboardEvent) {
    const items = event.clipboardData;
    const pastedText = items.getData('text');
    if (isNaN(+pastedText) || pastedText[0] !== '0') {
      setTimeout(() => {
        const field = this.fieldControl(blockId, fieldId);
        field.patchValue('');
      }, 0);
    }
  }

  onKeyUpPhone(blockId, fieldId, event: KeyboardEvent) {
    const field = this.fieldControl(blockId, fieldId);
    const phoneNumber = field.value || '';
    if ((phoneNumber[0] !== '0') || /* le 1er caractere est change par un nombre different de 0 */
      phoneNumber[1] === '0' /* 2eme caractere est toujours different de 0 */
    ) {
      let newPhone = '';
      if (phoneNumber) {
        const phone = Number(phoneNumber);
        newPhone = `0${phone ? phone : ''}`;
      }
      field.patchValue(newPhone);
    }
  }

  getErrorMessage(blockId, fieldId) {
    const field = this.fieldControl(blockId, fieldId);
    if (field.errors?.phone) {
      return 'Le numéro de téléphone n\'est pas valide';
    }
    if (field.errors?.email) {
      return 'Le courriel n\'est pas valide';
    }
    if (field.errors?.required) {
      return 'Le champ est obligatoire';
    }
  }

  ngOnDestroy(): void {
    this.uploadSubs.forEach(sub => sub.unsubscribe());
    this.subSink.unsubscribe();
  }

  exportPdfForm(form: FormModel) {
    this.pubSubSvc.publish('loading', true);
    this.subSink.sink = this.formSvc
      .exportPdfForm(form)
      .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
      .subscribe((data: Blob) => {
        const zipName = `${form.nom}-${this.formatDateForZip()}`;
        const fileName = `${zipName}.pdf`;
        saveAs(data, fileName);
      });
  }

  exportZipAttachementsForm(form: FormModel) {
    this.pubSubSvc.publish('loading', true);
    this.subSink.sink = this.formSvc
      .exportAttachementsForm(form)
      .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
      .subscribe((data: Blob) => {
        const zipName = `${form.nom}-${this.formatDateForZip()}`;
        const fileName = `${zipName}.zip`;
        saveAs(data, fileName);
    });
  }

  downloadSelectedFile(file: File) {
    this.subSink.sink = this.formSvc.downloadAttachement(file).subscribe(v => FileSaver.saveAs(v, file.name));
  }

  formatDateForZip() {
    return dateFnsAdaptor.format(new Date(), 'yyyy-MM-dd-HH-mm', { locale: fr });
  }

  /**
   * On stock les keys des champs du type File dans un tableau fileFieldKeys
   * On stock les fichiers dans un objet filesToUploadObject (fieldId: file)
   * @param {File} f
   * @param item le champ
   */

  handleFileInputChange(f: File, item: Field): void {
    if (!this.validateFile(f)) {
      this.snackSvc.toasty(
        'Pièce jointe',
        this.constants.notificationMessage.maxSizeFileWarning,
        typeToast.error,
        5_000
      );
      this.clearSelectedFile(item);
      return;
    }

    if (!this.fileFieldsKeys.includes(item.key)) {
      this.fileFieldsKeys = [...this.fileFieldsKeys, item.key];
    }
    this.fieldControl(item.block, item.id).setValue(f.name);

    const responseValue = this.demandeId ? this.findResponseField(item) : null;
    if (responseValue?.id) {
      this._uploadFileNow(f, item, responseValue);
    } else {
      // Pas encore de demande : le fichier sera envoyé à la sauvegarde
      this.fullFilesToUploadObject[item.key] = f;
    }
  }

  validateFile(f: File) {
    return !!(f && f.size < this.constants.maxSize);
  }

  /**
   * Un upload est-il en cours (tous champs ou un champ précis)
   */
  isUploading(item?: Field): boolean {
    return item ? this.uploadSubs.has(item.key) : this.uploadSubs.size > 0;
  }

  /**
   * Upload immédiat du fichier sur la demande existante (brouillon), sans passer par la sauvegarde
   */
  private _uploadFileNow(f: File, item: Field, responseValue: ReponseField): void {
    this._cancelUpload(item.key);
    delete this.fullFilesToUploadObject[item.key];
    this.uploadProgress.set(item.key, 0);
    this.uploadSubs.set(item.key, this.responsesSvc
      .uploadFileWithProgress(f, responseValue.id, this.demandeId)
      .pipe(finalize(() => {
        this.uploadSubs.delete(item.key);
        this.uploadProgress.delete(item.key);
      }))
      .subscribe({
        next: event => {
          if (event.type === HttpEventType.UploadProgress && event.total) {
            this.uploadProgress.set(item.key, Math.round(100 * event.loaded / event.total));
          } else if (event.type === HttpEventType.Response) {
            responseValue.value = f.name;
          }
        },
        error: () => {
          this.snackSvc.toasty(
            'Pièce jointe',
            `Le fichier ${f.name} n'a pas pu être envoyé, veuillez réessayer.`,
            typeToast.error,
            5_000
          );
          this.fileFieldsKeys = this.fileFieldsKeys.filter(k => k !== item.key);
          this.fieldControl(item.block, item.id)?.setValue(responseValue.value || '');
        }
      }));
  }

  /**
   * Alerte du navigateur si fermeture / rechargement de la page pendant un upload
   */
  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent): void {
    if (this.isUploading()) {
      event.preventDefault();
      event.returnValue = true;
    }
  }

  /**
   * Progression (0-100) de l'upload en cours d'un champ
   */
  uploadPercent(item: Field): number {
    return this.uploadProgress.get(item.key) ?? 0;
  }

  private _cancelUpload(key: number): void {
    this.uploadSubs.get(key)?.unsubscribe();
    this.uploadSubs.delete(key);
    this.uploadProgress.delete(key);
  }

  checkIfValueFileExist(item: Field) {
    return !!(this._findResponseField(item)?.value);
  }

  itemHasFile(item: Field | null | undefined): boolean {
    if (!item?.id) {
      return false;
    }

    return Object.prototype.hasOwnProperty.call(this.fullFilesToUploadObject, item.key);
  }

  clearSelectedFile(item: Field): void {
    const key = item.key;                       // même clé partout

    this._cancelUpload(key);

    /* 1. on delete le fichier dans les deux tableaux */
    delete this.filesToUploadObject[key];
    delete this.fullFilesToUploadObject[key];

    /* 2. on retire la clé de la liste suivie */
    this.fileFieldsKeys = this.fileFieldsKeys.filter(k => k !== key);

    /* 3. réinitialise l’input file */
    this.inputFiles
      .find(el => Number(el.nativeElement.id) === Number(key))
      ?.nativeElement.setAttribute('value', '');   // plus sûr que value = ''

    /* 4. supprime la copie serveur si elle existe */
    const fileValue = this.findResponseField(item);
    if (fileValue?.value) {
      this.responsesSvc.deleteFileResponse(fileValue).subscribe();
    }

    /* 5. nettoie le contrôle réactif */
    this.fieldControl(item.block, item.id)?.setValue('');
  }

  showClearBtn(item: Field | null | undefined): boolean {
    const control = this.fieldControl(item.block, item.id);
    return !!control.value;
  }

  /**
   * On Enleve les valeurs type file
   * Les valeurs type file vont etre traiter séparement
   * @param responseObj
   * @param fileFieldsKeys
   */

  filterValues(responseObj, fileFieldsKeys): void {
    Object.keys(responseObj).forEach((key) => {
      if (fileFieldsKeys.includes(Number(key))) {
        delete responseObj[key];
      }
    });
  }

  /**
   * On filtre les controls invalids
   * On ajoute une propriete showErrMsg qui sert a afficher le message d'erreure
   * @param params
   */
  findInvalidControls(params: ResponseFormModel) {
    // ne pas tenir compte des controle si le bloc n'est pas affiché
    let condBlok = true;
    for (const [key, formGroup] of Object.entries(this.filterForm.controls)) {
      if (key.startsWith('block-')) {
        const display = this.displayBlock(key);
        if (display && formGroup.invalid) {
          condBlok = false;
          break;
        }
      }
    }
    if (condBlok) {
      this.emitResponse.emit(params);
      return;
    }

    let controlsObj = {};
    if (this.filterForm.invalid) {
      for (const [key, formGroup] of Object.entries(this.filterForm.controls)) {
        controlsObj = {...controlsObj, ...formGroup['controls']};
      }
      for (const [key, formGroup] of Object.entries(controlsObj)) {
        formGroup['showErrMsg'] = formGroup['invalid'];
      }
      this.snackSvc.toasty('Demande Incomplete', 'Veuillez compléter votre demande.', typeToast.error);
    } else {
      this.emitResponse.emit(params);
    }
  }

  /**
   * Correction date du format si le champ est de format DATE, on laisse sinon
   * @param {Field} field
   * @param value
   * @private
   */
  private _transformFieldIfDate(field: Field, value) {
    if (field.options_obj.controlType === FieldType.TypeDate && value) {
      const dp: DatePipe = new DatePipe(this.locale);
      value = dp.transform(`${value}`, 'yyyy-MM-dd');
    }
    return value;
  }

  private _checkIfResponsesExist() {
    return !!(this.formModel &&
      this.formModel.form_responses && (this.formModel.form_responses as ResponseForm[]).length > 0 &&
      this.formModel.form_responses[0].response_objs);
  }

  /**
   * Trouve la réponse d'un champ item
   * @param item
   * @private
   */
  private _findResponseField(item): ReponseField {
    let field = null;
    if (this._checkIfResponsesExist()) {
      field = this._findResponseFieldById(item.id);
    }
    return field;
  }

  findResponseField(item): ReponseField {
    return this._findResponseField(item);
  }

  /**
  * Récupération de la valeur du bloc conditionné
  */
  private _getConditionBlockValue(blockId: number) {
    if (this.demandeId) {
      const formDemandes = this.formModel.form_responses as ResponseForm[];
      const conditionBlocksObjs: ConditionBlockResponseDemat[] = formDemandes.find(demande => demande.id === this.demandeId).condition_block_value_objs;
      const conditionBlockObj: ConditionBlockResponseDemat = conditionBlocksObjs?.find(itm => itm.block === blockId);
      return conditionBlockObj?.display;
    }
    return false;
  }

  /**
   * Récupération de toutes les demandes (formDemandes)
   * On trouve la demande sélectionnée
   * On récupére les reponses de la demande sélectionné
   */
  private _getResponsesObjsIfExist() {
    if (this.demandeId) {
      const formDemandes = this.formModel.form_responses as ResponseForm[];
      return formDemandes.find(demande => demande.id === this.demandeId).response_objs;
    }
    return [];
  }

  /**
   * Trouve un champ de la réponse existante
   * @param {number} fieldId
   * @private
   */
  private _findResponseFieldById(fieldId: number): ReponseField {
    let field = null;
    if (this._checkIfResponsesExist()) {
      field = this._getResponsesObjsIfExist().find(_resp => {
        const f = <Field>_resp.field;
        return f.id === fieldId;
      });
    }
    return field;
  }

  /**
   * Trouve un champ dans le modèle du formulaire, dans blocks
   * @return {Field} champ trouvé
   */
  private _findFormFieldById(fielId: number): Field {
    let field: Field = null;
    this.formModel.blocks.forEach(_block => {
      const findField = _block.fields_objs.find(_field => _field.id === fielId);
      if (findField) {
        field = findField;
        return;
      }
    });
    return field;
  }

  /**
   * Contrôle de champ simple : text, date, email, tel, fixe la valeur le cas échéant
   * @param {Field} field
   */
  private _generateFormField(field: Field): UntypedFormControl {
    const _field = this._findResponseField(field);
    const value = _field?.value !== null ? _field?.value : ''; // voir si null pt être une valeur
    return new UntypedFormControl(value, this.formSvc.genericFieldValidator(field.options_obj));
  }

  /**
   * Contrôle radio, un non choix est une valeur nulle
   * @param {Field} field
   * @private
   */
  private _generateRadioField(field: Field): UntypedFormControl {
    const _field = this._findResponseField(field);
    const value = _field?.value;
    return new UntypedFormControl(value, this.formSvc.genericFieldValidator(field.options_obj));
  }
  /**
   * Contrôle de champ checkbox
   * @param field
   * @private
   */
  private _generateCheckBoxGroup(field): UntypedFormArray {
    const _field = this._findResponseField(field);
    let choices;
    if (_field && _field.value) {
      choices = _field.value;
    } else {
      choices = field.options.options['options'];
    }
    const formArray = new UntypedFormArray([], this.formSvc.genericFieldValidator(field.options_obj));
    choices.forEach(option => {
      formArray.push(new UntypedFormGroup({
        key: new UntypedFormControl(option.key),
        value: new UntypedFormControl(option.value)
      }));
    });
    return formArray;
  }


  /**
   * On filtre les reponse du type File filesToUploadObject
   * On récupere 2 type de valeurs de reponse pour 2 traitement different
   * @param reponseStatus
   * @param preserveState
   */
  private _emitForm(reponseStatus: ReponseState, preserveState: boolean = false) {
    const responsesvaluesFields = this._mapFormToResponsesValuesFields();

    const conditionBlocksValue: { block: string; display: boolean }[] = [];
    const response: any[] = [];

    // Parcours unique des valeurs du formulaire
    // → on sépare directement les booléens (pour les blocs conditionnels)
    // → des autres valeurs (réponses classiques)
    Object.entries(this.filterForm.value).forEach(([key, value]) => {
      if (typeof value === 'boolean') {
        conditionBlocksValue.push({
          block: this.formCondtionBlockId(key),
          display: value
        });
      } else {
        response.push(value);
        // Applique les filtres nécessaires aux valeurs non booléennes
        this.filterValues(value, this.fileFieldsKeys);
      }
    });

    // Détermine l’état suivant de la réponse
    let nextState = reponseStatus;

    if (preserveState && reponseStatus === this.reponseState.temp) {
      // Si preserveState = true et l’état demandé est temp
      // → on réutilise le dernier état non-temp si disponible
      nextState = this.lastNonTempState ?? this.reponseState.temp;
    }

    // On sauvegarde l’état si ce n’est pas un état temporaire
    if (nextState !== this.reponseState.temp) {
      this.lastNonTempState = nextState;
    }

    const params: ResponseFormModel = {
      formId: this.formId.toString(),
      state: nextState,
      value: response,
      filesToUploadObject: this.filesToUploadObject,
      responses_value: responsesvaluesFields,
      condition_blocks_value: conditionBlocksValue,
    };

    // Si l’état final est "published", on valide les champs
    // Sinon on émet simplement la réponse
    if(this.creationAuto){
      this.emitResponse.emit(params);

    }else{
      if (nextState === this.reponseState.published) {
        this.findInvalidControls(params);
      } else {
        this.emitResponse.emit(params);
      }
    }

  }

  private _checkKeyDown(keyDown, ctrlKey) {
    return ['ArrowLeft', 'ArrowRight', 'Delete', 'Backspace', 'Home', 'End', 'Tab'].includes(keyDown) ||
      (ctrlKey && ['c', 'v', 'x'].includes(keyDown));
  }

  downloadFile(value) {
    this.subSink.sink = this.responsesSvc.getFileResponse(value).subscribe(v => FileSaver.saveAs(v, value.value));
  }

  displayBlock(blockKey: string) {
    return this.filterForm.get(this.formCondtionBlockName(blockKey)).value;
  }
  formCondtionBlockName(blockKey: string) {
    return `condition-${blockKey}`;
  }
  formCondtionBlockId(key: string) {
    // key = condition-bloc-<id>
    return key.split('-')[2];
  }

}
